import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { InvoiceList, InvoiceListRequest } from '../models/invoice.model';  

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  baseUrl = environment.baseUrl;
 
  constructor(private http: HttpClient) {}
  getRegularInvoice(request: InvoiceListRequest): Observable<InvoiceList[]> {
    var invoiceUrl = `${this.baseUrl}invoiceprocess/GetInvoiceProcess`;
    const params = new URLSearchParams();
    params.append('startDate', request.StartDate);
    params.append('endDate', request.EndDate);
    if(request.Status !== ''){
      params.append('Status', request.Status);
    }
    if(request.WorkOrderNumber !== ''){
      params.append('WorkOrderNumber', request.WorkOrderNumber);
    }
      
    var url = `${invoiceUrl}?${params.toString()}`;
    return this.http.get<InvoiceList[]>(url);
  }

  getToteInvoice(request: InvoiceListRequest): Observable<InvoiceList[]> {
    var toteinvoiceUrl = `${this.baseUrl}invoiceprocess/GetToteInvoiceProcess`;
    const params = new URLSearchParams();
    params.append('Month', request.Month.toString());
    params.append('Year', request.Year.toString());
    params.append('Status', request.Status); 
    if (request.CustomerId) {
      params.append('generatorId', request.CustomerId.toString());
    }
    if (request.StreamId) {
      params.append('streamId', request.StreamId.toString());
    }
    var url = `${toteinvoiceUrl}?${params.toString()}`;
    return this.http.get<InvoiceList[]>(url);
  }

  runMonthEndProcess(): Observable<any> {
    var url = `${this.baseUrl}invoiceprocess/ProcessMonthEndInvoices`;
    return this.http.post<any>(url, {});
  }

  reprocessRegularInvoice(workOrders: string[]): Observable<any> {
    var url = `${this.baseUrl}invoiceprocess/ProcessInvoice`;
    return this.http.post<any>(url, workOrders);
  }
}
